export default "<p>config works!</p>\r\n";